<script>
    import { mapActions, mapState } from "vuex";
    import { apiUrl } from "@/utils";
    import TheSvgIcon from "@main/packages/TheSvgIcon";
    import ProfileNavigationList from "@/components/ProfileNavigationList";
    import ThePersonalUserAvatar from "@/ThePersonal/ThePersonalUserAvatar";

    export default {
        name: "PersonalNavigationMenu",
        components: { TheSvgIcon, ProfileNavigationList, ThePersonalUserAvatar },
        props: {
            isMobile: Boolean,
        },
        data() {
            return {
                menuCurrentTitle: "Личный кабинет",
            };
        },
        computed: {
            ...mapState("Profile", ["user"]),
            isLoggedIn() {
                return this.user?.id;
            },
            userPhoto() {
                if (this.user?.photo?.small) {
                    return apiUrl(this.user.photo.small);
                }
                return false;
            },
            menuHeaderTitle() {
                return this.isLoggedIn ? "Кабинет" : "Войти";
            },
        },

        methods: {
            ...mapActions("Root", ["getCart"]),
            ...mapActions("Profile", ["logoutProfile"]),
            loginClickHandler() {
                if (!this.isLoggedIn) {
                    this.$popup.show("modal-profile-auth");
                    return;
                }
                if (this.$route.name !== "ThePersonalMain") {
                    this.$router.push({ name: "ThePersonalMain" });
                }
            },
            logoutClickHandler() {
                this.logoutProfile().then(() => {
                    if (this.$route.name !== "Home") {
                        this.$router.push({ name: "Home" });
                    }
                    this.getCart();
                });
            },
        },
    };
</script>

<template>
    <nav class="personal-navigation-menu" :class="{ 'is-mobile': isMobile }">
        <button class="personal-navigation-menu__icon outline" @click="loginClickHandler">
            <span class="personal-navigation-menu__image">
                <template v-if="isLoggedIn">
                    <img v-if="userPhoto" :src="userPhoto" alt="" />
                    <the-personal-user-avatar
                        v-else
                        :name="user.name"
                        :last-name="user.lastName"
                        is-small
                    ></the-personal-user-avatar>
                </template>

                <template v-else>
                    <the-svg-icon name="auth" :size-w="24"></the-svg-icon>
                </template>
            </span>
            <span class="personal-navigation-menu__text">{{ menuHeaderTitle }}</span>
        </button>

        <div class="personal-navigation-menu__dropdown" v-if="isLoggedIn">
            <profile-navigation-list></profile-navigation-list>
        </div>
    </nav>
</template>

<style lang="scss">
    .personal-navigation-menu {
        position: relative;
        display: none;
        &.is-mobile {
            display: block;
            padding: 8px 0;
        }
        @include bp($bp-desktop-sm) {
            display: block;
            cursor: pointer;
            &::before {
                content: "";
                position: absolute;
                top: -10px;
                bottom: -10px;
                left: 0;
                right: 0;
                pointer-events: none;
            }
            &:hover {
                .personal-navigation-menu__text {
                    color: $personal-enter-color--hover;
                }
                .personal-navigation-menu__image {
                    svg {
                        fill: $personal-enter-color--hover;
                    }
                }
                .personal-navigation-menu__dropdown {
                    transform: translateY(0);
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
    }

    .personal-navigation-menu__icon {
        position: relative;
        z-index: 5;
        display: flex;
        align-items: flex-end;
    }

    .personal-navigation-menu__image {
        @include box(24px);
        margin-right: 4px;
        border-radius: 50%;
        overflow: hidden;
        svg {
            transition: fill 0.3s ease-in-out;
        }
    }

    .personal-navigation-menu__text {
        margin-right: 20px;
        color: $personal-enter-color;
        font-size: $personal-enter-size;
        line-height: $personal-enter-height;
        font-weight: $personal-enter-weight--mobile;
        transition: 0.3s ease-in-out all;
        @include bp($bp-desktop-sm) {
            font-weight: $personal-enter-weight;
        }
    }

    .personal-navigation-menu__dropdown {
        display: none;
        @include bp($bp-desktop-sm) {
            position: absolute;
            z-index: 20;
            left: -100%;
            display: block;
            opacity: 0;
            visibility: hidden;
            transform: translateY(-4px);
            transition: opacity 0.2s ease-in, transform 0.2s ease-in;
        }
    }
</style>
